goog.provide("shadow.js.shim.module$dayjs$locale$vi");
goog.provide("module$shadow_js_shim_module$dayjs$locale$vi");
shadow.js.shim.module$dayjs$locale$vi = shadow.js.nativeProvides["dayjs/locale/vi"] = require("dayjs/locale/vi");
module$shadow_js_shim_module$dayjs$locale$vi.default = shadow.js.shim.module$dayjs$locale$vi;
